// The editor's existing empty graph, shared with headless generation.
export const DEFAULT_EMPTY_SCENARIO = {
  '3dcf1b68-15e2-4d25-b5f0-f08daba97fa7': {
    branchId: '1', id: '3dcf1b68-15e2-4d25-b5f0-f08daba97fa7', type: 'StartNode',
    data: { label: 'Play', deserialized: true },
    nextNodes: ['b472b457-9ce0-41ba-a7e7-2b3cacb77505'], prevNodes: [],
  },
  'b472b457-9ce0-41ba-a7e7-2b3cacb77505': {
    branchId: '1', id: 'b472b457-9ce0-41ba-a7e7-2b3cacb77505',
    parentNodeId: '3dcf1b68-15e2-4d25-b5f0-f08daba97fa7', type: 'FinishNode',
    data: { label: 'Finish', deserialized: true }, nextNodes: [],
    prevNodes: ['3dcf1b68-15e2-4d25-b5f0-f08daba97fa7'],
  },
};

export const createEmptyScenario = () => JSON.parse(JSON.stringify(DEFAULT_EMPTY_SCENARIO));
